<template lang='pug'>
v-card(flat)
  v-card-text
    //-
    div(class='mb-3')
      div(class='grey--text') Клиент
      div(class='title') {{ client.full_name }}
    //-
    div(v-if='client.phone' class='mb-2')
      div(class='grey--text') Контактный телефон
      div(class='subheading') {{ client.phone | phone }}
    //-
    div(v-if='client.birthday' class='mb-2')
      div(class='grey--text') Дата рождения
      div(class='subheading') {{ client.birthday | date }}
</template>

<script>
export default {
  props: ['client']
}
</script>
